import { useQuery } from 'react-query';

import { PaywallProps } from '@components/Paywall';
import {
  ARTICLE_PAYWALL_PROPS_KEY,
  ArticlePaywallPropsResponse,
  getArticlePaywallProps,
} from '@utils/backend-api/articles';

export default function useArticlePaywallProps({
  articleId,
  isTwoOptPaywall,
  offerCode,
  shareGuid,
}: Pick<PaywallProps, 'articleId' | 'isTwoOptPaywall' | 'offerCode' | 'shareGuid'>) {
  const { data: articlePaywallProps, isLoading: isArticlePaywallPropsLoading } =
    useQuery<ArticlePaywallPropsResponse>([ARTICLE_PAYWALL_PROPS_KEY, articleId], () =>
      getArticlePaywallProps({ articleId, isTwoOptPaywall, offerCode, shareGuid })
    );

  return { articlePaywallProps, isArticlePaywallPropsLoading };
}
